<template>
  <span
    :class="{'figure': true, [`figure--${icon}`]: true }"
    :style="{ color }"
    @click="$emit('click')"
  />
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    icon: {
      required: true,
      type: String,
    },
    color: {
      required: false,
      type: String,
      default: () => null,
    },
  },
})
export default class Icon extends Vue {
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Icon.vue